// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P3MRo","left":"styles_left__iejoe"};